module.exports = __webpack_public_path__ + "static/img/dy1-5.a7cff03.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-5.png
// module id = 944
// module chunks = 0